// extracted by mini-css-extract-plugin
export default {"container":"ExpertRecordsDetailStyles_container__+sv8d","viewScore":"ExpertRecordsDetailStyles_viewScore__DebLC","backButtonNew":"ExpertRecordsDetailStyles_backButtonNew__xeujk"};